// useUpdateUserSettingsApi.ts
import { useMutation } from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

export type UpdateUserSettingsPayload = {
  allow_challenge?: boolean;
  chessboard_theme?: string; // e.g. "default-yellow-white"
  // Player Profile Milestone 5: per-field visibility toggles for a
  // non-owner viewer of this user's public profile, e.g. {location: false}.
  // Merged server-side with any existing keys, not replaced wholesale.
  profile_visibility?: {location?: boolean};
};

export type UpdateUserSettingsResponse = {
  success: boolean;
  data?: {
    allow_challenge: boolean;
    chessboard_theme: string;
    profile_visibility?: {location?: boolean};
  };
  error?: string;
  errors?: Record<string, string>;
};

export default function useUpdateUserSettingsApi(
  handleOnSuccess?: (data: UpdateUserSettingsResponse) => void,
  handleOnError?: (data: UpdateUserSettingsResponse) => void
) {
  const mutation = useMutation<UpdateUserSettingsResponse, Error, UpdateUserSettingsPayload>(
    async (payload) => {
      const res = await ChessRestClient.post('learning/update_user_settings/', payload);
      return res.data as UpdateUserSettingsResponse;
    },
    {
      onSuccess: (data) => {
        if (handleOnSuccess && data?.success) handleOnSuccess(data);
        else if (handleOnError && !data?.success) handleOnError(data);
      },
    }
  );

  return {
    ...mutation,
    updateSettings: mutation.mutate,            // call with payload
    updateSettingsAsync: mutation.mutateAsync,  // awaitable version
  };
}
